import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import FormComponent from '../FormComponent/FormComponent';
import BtnComponent from '../buttonComponent/BtnComponent';
import { CHANGE_PASSWORD } from '../../services/userQueries/userService';
import { isObjectEmpty, validatePassword } from '../../shared/helper';
import { useMutation } from '@apollo/client';
import { useSnackbar } from 'notistack';
import { SimpleBackdrop } from '../SimpleBackdropComponent/SimpleBackdrop';
import { CREATE_PASSWORD, ERROR_MSGS } from '../../shared/Strings';

const createAccountValues = {
  password: '',
  confirmpassword: '',
};

const CreatePassword = ({ phoneNumber, setScreenNumber }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [accountFormValues, setAccountFormValues] =
    useState(createAccountValues);
  const [accountFormErrors, setAccountFormErrors] = useState({});
  const [changePassword, { data, loading }] = useMutation(CHANGE_PASSWORD, {
    fetchPolicy: 'no-cache',
    onError: err => {
      enqueueSnackbar(CREATE_PASSWORD.ON_ERROR_TEXT.WENT_WRONG_TEXT, {
        variant: 'error',
      });
    },
  });

  const accountHandleChange = e => {
    const { name, value } = e.target;
    setAccountFormValues({ ...accountFormValues, [name]: value });
  };

  const accountHandleSubmit = e => {
    e.preventDefault();
    setAccountFormErrors(accountValidate(accountFormValues));
    if (isObjectEmpty(accountValidate(accountFormValues))) {
      changePassword({
        variables: {
          updatePasswordRequest: {
            phone: phoneNumber,
            password: accountFormValues.confirmpassword,
          },
        },
      });
    }
  };

  useEffect(() => {
    if (data) {
      setScreenNumber(4);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const accountValidate = values => {
    const errors = {};

    if (!values.password) {
      errors.password = ERROR_MSGS.REQUIRED_FIELD.PASSWORD;
    } else if (values.password.length < 8) {
      errors.password = ERROR_MSGS.PASSWORD_LENGTH_8;
    } else if (validatePassword(values.password)) {
      errors.password = ERROR_MSGS.PASSWORD_MUST_INCLUDE;
    }

    if (!values.confirmpassword) {
      errors.confirmpassword = ERROR_MSGS.CONFIRM_PASSWORD;
    } else if (values.confirmpassword !== values.password) {
      errors.confirmpassword = ERROR_MSGS.PASSWORD_NOT_MATCH;
    }

    return errors;
  };

  const inputFieldArray = [
    {
      title: CREATE_PASSWORD.LABEL.password,
      placeholder: CREATE_PASSWORD.PLACE_HOLDER.password,
      type: 'password',
      onChange: accountHandleChange,
      name: 'password',
      value: accountFormValues.password,
      errorMessage: accountFormErrors.password,
    },
    {
      title: CREATE_PASSWORD.LABEL.confirm_password,
      placeholder: CREATE_PASSWORD.PLACE_HOLDER.confirm_password,
      type: 'password',
      onChange: accountHandleChange,
      name: 'confirmpassword',
      value: accountFormValues.confirmpassword,
      errorMessage: accountFormErrors.confirmpassword,
    },
  ];

  return (
    <Box>
      <Typography variant="title">{CREATE_PASSWORD.TITLE}</Typography>
      <Box component="form" onSubmit={accountHandleSubmit} sx={{ mt: 5 }}>
        <FormComponent inputFieldArray={inputFieldArray}></FormComponent>
        <BtnComponent
          type="submit"
          title={CREATE_PASSWORD.CHANGE_PASSWORD}
          fullWidth
          sx={{ mt: 4 }}
        />
      </Box>
      <SimpleBackdrop open={loading} />
    </Box>
  );
};

export default CreatePassword;
